<template>
  <v-tooltip attach=".image-container" bottom>
    <template v-slot:activator="{ on }">
      <div
        slot="activator"
        :class="{
          point: geometry.type === 'POINT',
          rect: geometry.type === 'RECTANGLE',
          pointer: true,
          highlighted: active,
          'elevation-3': true
        }"
        :style="{
          width: `${geometry.width}%`,
          height: `${geometry.height}%`,
          top: `${geometry.y}%`,
          left: `${geometry.x}%`
        }"
        v-on="on"
      />
    </template>

    <div class="py-2" v-html="content" />
    <v-divider dark />
    <div class="py-1" v-html="author" />
  </v-tooltip>
</template>

<script>
export default {
  name: 'TaskPointer',
  props: {
    geometry: {
      type: Object
    },
    id: String,
    active: {
      type: Boolean,
      default: false
    },
    content: String,
    author: String
  },
  computed: {
    type: function() {
      if (this.geometry.width > this.geometry.height) return 'RECTANGLE';
      else return 'POINT';
    }
  }
};
</script>

<style scoped>
.pointer {
  position: absolute;
  background: transparent;
}

.highlighted {
  border-color: var(--red) !important;
}

.point {
  min-width: 25px;
  min-height: 25px;
  border: 5px solid var(--blue);
  border-radius: 50%;
}

.rect {
  border: dashed 2px black;
  box-shadow: 0px 0px 1px 1px white inset;
  box-sizing: border-box;
  -webkit-transition: box-shadow 0.21s ease-in-out;
  transition: box-shadow 0.21s ease-in-out;
}
</style>
